<template>
  <table class="slds-table slds-table_cell-buffer slds-table_bordered">
    <thead>
      <tr class="slds-line-height_reset">
        <th class scope="col">
          <div class="slds-truncate" title="Id">Id</div>
        </th>
        <th class scope="col">
          <div class="slds-truncate" title="Type">Type</div>
        </th>
        <th class scope="col">
          <div class="slds-truncate" title="Created Date">Created Date</div>
        </th>
        <th class scope="col">
          <div class="slds-truncate" title="Start Date">Start Date</div>
        </th>
        <th class scope="col">
          <div class="slds-truncate" title="Status">Status</div>
        </th>
        <th class scope="col">
          <div class="slds-truncate" title="Status Detail">Status Detail</div>
        </th>
        <th class scope="col">
          <div class="slds-truncate" title="Detail">Detail</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr class="slds-hint-parent" v-for="row in rows" :key="row.id">
        <td>
          <div class="slds-truncate" :title="row.id">{{row.id}}</div>
        </td>
        <td>
          <div class="slds-truncate" :title="row.type">{{row.type}}</div>
        </td>
        <td>
          <div class="slds-truncate" :title="row.createdDate | formatDate($t('general.dateFormat'))">{{row.createdDate | formatDate($t('general.dateFormat'))}}</div>
        </td>
        <td>
          <div class="slds-truncate" :title="row.startDate | formatDate($t('general.dateFormat'))">{{row.startDate | formatDate($t('general.dateFormat'))}}</div>
        </td>
        <td>
          <div class="slds-truncate" :title="row.status">{{row.status}}</div>
        </td>
        <td>
          <div class="slds-truncate" :title="row.statusDetail">
            <pre>{{row.statusDetail}}</pre>
          </div>
        </td>
        <td>
          <div class="slds-truncate" :title="row.detail">
            <pre>{{row.detail}}</pre>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    rows: Array
  }
}
</script>
